import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface PasswordGateProps {
  onUnlock: () => void;
}
// =========================================
// === EDITEAZĂ CUVÂNTUL ȘI INDICIUL AICI ===
// =========================================
const WORD = 'LOS PERROS';
const CLUE = 'Cine sare este...?';
// =========================================
const MAX_WRONG = 6;
// QWERTY keyboard layout
const KEYBOARD_ROWS = [['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'], ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'], ['Z', 'X', 'C', 'V', 'B', 'N', 'M']];
const HangmanFigure: React.FC<{
  wrong: number;
}> = ({
  wrong
}) => {
  return <svg width="100" height="120" viewBox="0 0 100 120" stroke="#C8C8CE" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-34">
      <line x1="8" y1="115" x2="60" y2="115" data-id="element-35" />
      <line x1="22" y1="115" x2="22" y2="8" data-id="element-36" />
      <line x1="22" y1="8" x2="65" y2="8" data-id="element-37" />
      <line x1="65" y1="8" x2="65" y2="22" data-id="element-38" />

      <AnimatePresence data-id="element-39">
        {wrong >= 1 && <motion.circle key="head" cx="65" cy="33" r="9" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-40" />}
        {wrong >= 2 && <motion.line key="body" x1="65" y1="42" x2="65" y2="78" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-41" />}
        {wrong >= 3 && <motion.line key="leftArm" x1="65" y1="52" x2="52" y2="62" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-42" />}
        {wrong >= 4 && <motion.line key="rightArm" x1="65" y1="52" x2="78" y2="62" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-43" />}
        {wrong >= 5 && <motion.line key="leftLeg" x1="65" y1="78" x2="55" y2="95" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-44" />}
        {wrong >= 6 && <motion.line key="rightLeg" x1="65" y1="78" x2="75" y2="95" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.4
      }} data-id="element-45" />}
      </AnimatePresence>
    </svg>;
};
export const PasswordGate: React.FC<PasswordGateProps> = ({
  onUnlock
}) => {
  const [guessed, setGuessed] = useState<Set<string>>(new Set());
  const [wrong, setWrong] = useState(0);
  const [won, setWon] = useState(false);
  const [lost, setLost] = useState(false);
  const [shakeKey, setShakeKey] = useState(0);
  const uniqueLetters = new Set(WORD.replace(/ /g, '').split(''));
  const handleGuess = (letter: string) => {
    if (guessed.has(letter) || won || lost) return;
    const newGuessed = new Set(guessed);
    newGuessed.add(letter);
    setGuessed(newGuessed);
    if (WORD.includes(letter)) {
      const allFound = [...uniqueLetters].every(l => newGuessed.has(l));
      if (allFound) {
        setWon(true);
        setTimeout(onUnlock, 2600);
      }
    } else {
      const newWrong = wrong + 1;
      setWrong(newWrong);
      setShakeKey(k => k + 1);
      if (newWrong >= MAX_WRONG) {
        setTimeout(() => setLost(true), 700);
      }
    }
  };
  // Physical keyboard support (desktop)
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (won || lost) return;
      const k = e.key.toUpperCase();
      if (k.length === 1 && k >= 'A' && k <= 'Z') {
        handleGuess(k);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guessed, wrong, won, lost]);
  const reset = () => {
    setGuessed(new Set());
    setWrong(0);
    setWon(false);
    setLost(false);
  };
  const renderKey = (letter: string) => {
    const isGuessed = guessed.has(letter);
    const inWord = WORD.includes(letter);
    const isCorrect = isGuessed && inWord;
    const isWrong = isGuessed && !inWord;
    return <motion.button key={letter} onClick={() => handleGuess(letter)} disabled={isGuessed || won || lost} aria-label={`Litera ${letter}${isCorrect ? ', ghicită corect' : isWrong ? ', greșită' : ''}`} className={`flex-1 min-w-0 aspect-[3/4] sm:aspect-[4/5] max-w-[42px] sm:max-w-[48px] rounded text-xs sm:text-sm font-inter font-medium transition-colors duration-200 ${isCorrect ? 'bg-silver text-royal-blue' : isWrong ? 'bg-cream/5 text-cream/25' : 'bg-cream/10 text-cream hover:bg-cream/20 active:bg-cream/30'}`} whileTap={!isGuessed && !won && !lost ? {
      scale: 0.88
    } : undefined} data-id="element-46">
        {letter}
      </motion.button>;
  };
  return <div className="relative w-full h-full flex flex-col items-center justify-center px-4 py-6 overflow-hidden" data-id="element-47">
      <motion.div key={shakeKey} animate={won ? {
      opacity: 0,
      transition: {
        duration: 0.6,
        delay: 0.3
      }
    } : shakeKey > 0 ? {
      x: [0, -6, 6, -4, 4, 0],
      opacity: 1
    } : {
      opacity: 1
    }} transition={{
      duration: 0.35
    }} className="w-full flex flex-col items-center" data-id="element-48">
        <div className="mb-5" data-id="element-49">
          <HangmanFigure wrong={wrong} data-id="element-50" />
        </div>

        <div className="font-marker font-bold text-cream tracking-wider mb-6 flex flex-wrap justify-center gap-x-1.5 sm:gap-x-2 px-2" style={{
        fontSize: 'clamp(1.75rem, 7vw, 3rem)'
      }} aria-label={`Cuvânt de ghicit, ${WORD.length} caractere`} data-id="element-51">
          {WORD.split('').map((char, i) => {
          if (char === ' ') {
            return <span key={i} className="inline-block w-3 sm:w-5" aria-hidden="true" data-id="element-52" />;
          }
          const revealed = guessed.has(char) || won;
          return <span key={i} className="inline-block text-center border-b border-silver/40 pb-1" style={{
            minWidth: '0.9em'
          }} data-id="element-53">
                {revealed ? <motion.span initial={{
              scale: 0,
              opacity: 0,
              y: 10
            }} animate={{
              scale: 1,
              opacity: 1,
              y: 0
            }} transition={{
              type: 'spring',
              stiffness: 350,
              damping: 18
            }} className="inline-block" data-id="element-54">
                    {char}
                  </motion.span> : <span className="opacity-0" data-id="element-55">_</span>}
              </span>;
        })}
        </div>

        {/* QWERTY keyboard */}
        <div className="flex flex-col gap-1.5 sm:gap-2 max-w-md w-full" data-id="element-56">
          {KEYBOARD_ROWS.map((row, idx) => <div key={idx} className="flex justify-center gap-1 sm:gap-1.5" style={{
          paddingLeft: idx === 1 ? '4%' : idx === 2 ? '10%' : 0,
          paddingRight: idx === 1 ? '4%' : idx === 2 ? '10%' : 0
        }} data-id="element-57">
              {row.map(renderKey)}
            </div>)}
        </div>
      </motion.div>

      {/* Win celebration */}
      <AnimatePresence data-id="element-58">
        {won && <motion.div key="win" className="absolute inset-0 flex items-center justify-center pointer-events-none z-40 px-6" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-59">
            <motion.div className="text-center" initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: [0.5, 1.15, 1, 1.1],
          opacity: [0, 1, 1, 0]
        }} transition={{
          duration: 2.6,
          times: [0, 0.25, 0.7, 1]
        }} data-id="element-60">
              <p className="font-marker font-bold text-cream leading-none" style={{
            fontSize: 'clamp(3rem, 14vw, 7rem)'
          }} data-id="element-61">
                ¡Los Perros!
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Game over overlay */}
      <AnimatePresence data-id="element-62">
        {lost && <motion.div key="lost" className="absolute inset-0 flex flex-col items-center justify-center z-50 px-6 text-center" style={{
        backgroundColor: 'var(--royal-blue)'
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.4
      }} data-id="element-63">
            <motion.p className="font-marker font-bold text-cream text-4xl sm:text-5xl mb-6" initial={{
          y: 10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.1
        }} data-id="element-64">
              Aproape!
            </motion.p>
            <motion.p className="font-inter text-silver/70 text-xs sm:text-sm uppercase tracking-[0.25em] mb-2" initial={{
          y: 10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.25
        }} data-id="element-65">
              Indiciu
            </motion.p>
            <motion.p className="font-marker text-cream text-2xl sm:text-3xl mb-10 max-w-sm" initial={{
          y: 10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.35
        }} data-id="element-66">
              {CLUE}
            </motion.p>
            <motion.button onClick={reset} className="font-inter text-cream/80 hover:text-cream uppercase tracking-widest text-sm pb-1 border-b border-cream/40 hover:border-cream transition-colors" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.55
        }} data-id="element-67">
              Mai încearcă
            </motion.button>
          </motion.div>}
      </AnimatePresence>
    </div>;
};